import { render, staticRenderFns } from "./MyBadges.vue?vue&type=template&id=50faccae&scoped=true"
import script from "./MyBadges.vue?vue&type=script&lang=js"
export * from "./MyBadges.vue?vue&type=script&lang=js"
import style0 from "./MyBadges.vue?vue&type=style&index=0&id=50faccae&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50faccae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\business\\yoyotravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50faccae')) {
      api.createRecord('50faccae', component.options)
    } else {
      api.reload('50faccae', component.options)
    }
    module.hot.accept("./MyBadges.vue?vue&type=template&id=50faccae&scoped=true", function () {
      api.rerender('50faccae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mine/MyBadges.vue"
export default component.exports